<style src="./TabPetCreate.scss" lang="scss"></style>
<i18n src="./TabPetCreate.yaml" lang="yaml"></i18n>
<script src="./TabPetCreate.js"></script>

<template>
  <div class="myaccount-content">
    <div class="login-register-wrap">
      <h3> {{ t('createPetForm') }} </h3>
      <div class="login-register-form">

        <BaseForm
            :vuelidate="v"
            :onSubmit="customerCreatePet"
            #default="{ error }"
        >
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Pet_name.$model"
                :vuelidate="v.Pet_name"
                :label="t('Pet_name')"
                type="text"
            />
          </div>
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Pet_age.$model"
                :vuelidate="v.Pet_age"
                :label="t('Pet_age')"
                type="text"
            />
          </div>
          <div class="sin-login-register">
            <BaseSelector
                v-model="v.Pet_Size.$model"
                :vuelidate="v.Pet_Size"
                :label="t('Pet_Size')"
            />
          </div>
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Pet_breed.$model"
                :vuelidate="v.Pet_breed"
                :label="t('Pet_breed')"
                type="text"
            />
          </div>
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Allergies__diseases.$model"
                :vuelidate="v.Allergies__diseases"
                :label="t('Allergies__diseases')"
                type="text"
            />
          </div>
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Vaccinations.$model"
                :vuelidate="v.Vaccinations"
                :label="t('Vaccinations')"
                type="text"
            />
          </div>
          <!-- As the graphql endpoint is not supporting the value below
          <div class="sin-login-register">
            <BaseInput
                v-model="v.short_description.$model"
                :vuelidate="v.short_description"
                :label="t('short_description')"
                type="text"
            />
          </div>
          <div class="sin-login-register">
            <BaseInput
                v-model="v.Extra_information.$model"
                :vuelidate="v.Extra_information"
                :label="t('Extra_information')"
                type="text"
            />
          </div>-->
<!--          <div class="sin-login-register">-->
          <!--            <BaseInput-->
          <!--                v-model="v.image.$model"-->
          <!--                :vuelidate="v.image"-->
          <!--                :label="t('image')"-->
          <!--                type="image"-->
          <!--            />-->
          <!--          </div>-->

            <div class="login-register-btn">
              <button data-test="login-form-submit">
                {{ t('submitPetBtn') }}
              </button>
            </div>

          <ServerError
              class="mb-20"
              :error="error"
              v-slot="{ graphQLError }"
          >{{ getErrorMessage(graphQLError) }}
          </ServerError
          >
        </BaseForm>
      </div>
    </div>
  </div>
</template>